export default __webpack_public_path__ + "static/media/Pause-noFill.86aa3668.svg";